import confetti from 'canvas-confetti';

export const useConfetti = () => {
  const triggerConfetti = async (options?: confetti.Options) => {
    const defaultOptions: confetti.Options = {
      particleCount: 300,
      spread: 100,
      origin: { y: 0.3 },
    };

    await confetti({
      ...defaultOptions,
      ...options,
    });
  };

  return {
    triggerConfetti,
  };
};
